import { useRouter } from "next/router";
import { useEffect } from "react";
import useCart from "./services/useCart.hook";
import posProductCore from "../core/product.core";
import { useQueryClient } from "@tanstack/react-query";

export default function useBarcodeScanner() {
  const { push, pathname } = useRouter();
  const { addItem, updateItem, getProductWarehouseId, cart } = useCart();
  const queryClient = useQueryClient();

  let code = "";
  let isReading = false;

  // eslint-disable-next-line
  function handleKeyPress(e: KeyboardEvent) {
    if (e.key !== "Enter") {
      code += e.key;
    } else {
      processCode(code);
      code = "";
    }

    if (!isReading) {
      isReading = true;
      setTimeout(() => {
        code = "";
        isReading = false;
      }, 2000); //200 works fine for me but you can adjust it
    }
  }

  useEffect(() => {
    document.addEventListener("keypress", handleKeyPress);

    return () => {
      document.removeEventListener("keypress", handleKeyPress);
    };
  }, [handleKeyPress]);

  function processCode(code: string) {
    if (/\\\d{6}/.test(code)) {
      code = code.substring(7);
    }

    const productId = getProductId(code);

    if (productId === undefined) return;

    if (pathname === "/") {
      addToCart(productId);
    } else {
      push("/product/" + productId);
    }
    // if in cart page, add to cart
    // if not, go product page
  }

  function getProductId(code: string) {
    try {
      const obj = JSON.parse(code);
      if (obj.id === undefined) return;

      return obj.id;
    } catch (e) {
      return undefined;
    }
  }

  async function addToCart(productId: string) {
    const product = await posProductCore.getPosProduct(productId);
    const inCart = cart?.items?.find((item: any) => item.product.id === productId);

    if (!inCart) {
      const warehouseId = getProductWarehouseId(product);
      //  @ts-ignore
      addItem({ product, quantity: 1, warehouseId });
      queryClient.invalidateQueries({ queryKey: ["PosCartCount"] });
    } else {
      const updatedQuantity = inCart.quantity + 1;
      updateItem({ cartItemId: inCart.id, product, quantity: updatedQuantity, warehouseId: inCart.warehouseId });
    }
  }
}
